<script>
  export let member;
  export let selectedIndex;
  export let selectedMessage;

  import { fly } from "svelte/transition";
  let finalText = selectedMessage;
  $: selectedMessage, (finalText = selectedMessage);

  $: tweetLink = member
    ? `https://twitter.com/intent/tweet?text=Hi ${member["Twitter"]} 👋 ${finalText}&url=https://houstonbudget.cool&hashtags=HouBudget&original_referer=https://houstonbudget.cool`
    : `https://twitter.com/intent/tweet?text=${finalText}&url=https://houstonbudget.cool&hashtags=HouBudget&original_referer=https://houstonbudget.cool`;
</script>

{#key selectedIndex}
  <div in:fly={{ x: -20 }} class="container {member ? '' : 'noMemberSelected'}">
    <label for="textarea" hidden>Enter your message</label>
    <textarea
      name="textarea"
      id="textarea"
      on:change={(e) => (finalText = e.target.value)}
      >{selectedMessage}</textarea
    >
    <div class="share-buttons" class:disabled={!finalText || finalText == ""}>
      <a
        tabindex="0"
        role="button"
        class:disabled={member
          ? `Hi ${member["Twitter"]} 👋 ${finalText} https://houstonbudget.cool #HouBudget`
              .length > 280
          : `${finalText} https://houstonbudget.cool #HouBudget`.length > 280}
        href={tweetLink}
        class="share-button"
        target="_blank"
        rel="noopener noreferrer">Tweet</a
      >
      {#if member}
        <a
          tabindex="0"
          role="button"
          href="mailto:{member[
            'Email'
          ]}?subject=Reaching out about the FY23 budget&body=Hi {member[
            'Name'
          ]}! I'm a resident of District {member[
            'District'
          ]}, and I'm reaching out about this year's budget. {finalText}"
          class="share-button"
          target="_blank"
          rel="noopener noreferrer">Email</a
        >
      {/if}
    </div>
  </div>
{/key}

<style>
  .noMemberSelected {
    max-width: 768px;
    margin: auto;
  }

  textarea {
    font-size: 1rem;
    resize: none;
    min-height: 130px;
    width: 100%;
    font-family: var(--font-sans);
    padding: 0.5rem;
    background: var(--primary-color-base);
    outline: 1px solid var(--accent-color);
    margin-bottom: 0.5rem;
    border: none;
    font-family: "Courier New", Courier, monospace;
    color: rgb(25, 25, 25);
    font-weight: 500;
    transition: all 300ms ease;
  }

  textarea:focus,
  textarea:active {
    outline: 2px solid var(--accent-color);
  }

  .disabled {
    cursor: not-allowed;
  }

  .disabled .share-button,
  .share-button.disabled {
    pointer-events: none;
    background: var(--primary-color);
    opacity: 0.7;
  }

  .share-buttons {
    display: flex;
    justify-content: flex-end;
  }

  .share-button {
    background: white;
    padding: 0.35rem;
    padding-bottom: 0.425rem;
    font-weight: 600;
    margin-top: 0.15rem;
    display: inline-block;
    text-transform: uppercase;
    border: 1px solid var(--accent-color);
    border-radius: 2px;
    transition: all 500ms ease;
  }

  .share-button {
    margin-right: 5px;
  }

  .share-button:hover {
    text-decoration: none;
  }
</style>
